var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_304_310)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.8828 1.92168C12.2812 0.468559 10.6953 -0.304879 9.17969 0.109183L2.30469 1.98418C0.945313 2.35918 0 3.59356 0 4.99981C0 24.3279 15.6719 39.9998 35 39.9998C36.4062 39.9998 37.6406 39.0545 38.0156 37.6951L39.8906 30.8201C40.3047 29.3045 39.5312 27.7186 38.0781 27.117L30.5781 23.992C29.3047 23.4607 27.8281 23.8279 26.9609 24.8982L23.8047 28.7498C18.3047 26.1482 13.8516 21.6951 11.25 16.1951L15.1016 13.0467C16.1719 12.1717 16.5391 10.7029 16.0078 9.4295L12.8828 1.9295V1.92168Z",
    fill: "#FFFEF7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_304_310"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phone-icon.742c072598d66c11aa373c7d6cf74f70.svg";
export { ForwardRef as ReactComponent };